import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import TextInput from '../InputComponent/TextInput';
import SelectInput from '../InputComponent/SelectInput';

const RuleFormModal = ({ isOpen, onClose, onSave, rule, plans, isLoading }) => {
    const initialFormState = {
        serial_no: '',
        endpoint: '',
        status: 'inactive',
    };

    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        if (rule) {
            setFormData({
                serial_no: rule.serial_no,
                endpoint: rule.endpoint,
                status: rule.status,
            });
        } else {
            setFormData({ ...initialFormState });
        }
    }, [rule, isOpen, plans]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.serial_no || !formData.endpoint) {
            toast.error('Serial Number and Endpoint are required.');
            return;
        }
        onSave({ ...formData, 'id': rule?.id });
    };

    const isEditing = !!rule;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={isEditing ? 'Edit Device Configuration' : 'Add Device Configuration'}>
            <form onSubmit={handleSubmit} className="space-y-4">
                <TextInput label={"Serial Number"} type="text" name="serial_no" value={formData.serial_no} onChange={handleChange} isRequired={true}/>
                <TextInput label={"Endpoint"} type="text" name="endpoint" value={formData.endpoint} onChange={handleChange}  isRequired={true}/>
                <SelectInput label={"Status"} name="status" value={formData.status} onChange={handleChange}>
                    <option value={"active"}>Active</option>
                    <option value={"inactive"}>Inactive</option>
                </SelectInput> 
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button disabled={isLoading} type="submit" className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">{isLoading ? 'Loading' : ' Save Device'}</button>
                </div>
            </form>
        </Modal>
    );
};

export default RuleFormModal;
